import React, { useState, useEffect, useRef } from 'react';
import { Link, useLocation } from 'react-router-dom';


export const PublicSkipContentLink: React.FC = () => {
    return (<>
        <div className="skip-link-wrapper">
            <div className="shell">
                <div className="skip-link-wrapper__inner">
                    <a href="#content" className="skip-link js-skip" title='Skip to content'>Skip to Content</a>
                </div>
            </div>
        </div>
    </>);
}